import { Grid, Table } from '@mui/material';
import {
  CenteredTd,
  Th10,
} from 'spw-components/programming-scenarios/building-hs-sc-scenario/styles';
import React from 'react';
import { GridSize } from '@mui/material/Grid/Grid';

const CirculationMultiplierTable = ({
  headerText,
  gridSize,
}: {
  headerText: string;
  gridSize: GridSize;
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={gridSize}>
        <Table>
          <thead>
            <tr>
              <Th10>{headerText}</Th10>
              <Th10>MULTIPLIER</Th10>
            </tr>
          </thead>
          <tbody>
            <tr>
              <CenteredTd>30%</CenteredTd>
              <CenteredTd>.43</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>31%</CenteredTd>
              <CenteredTd>.45</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>32%</CenteredTd>
              <CenteredTd>.47</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>33%</CenteredTd>
              <CenteredTd>.49</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>34%</CenteredTd>
              <CenteredTd>.52</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>35%</CenteredTd>
              <CenteredTd>.54</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>36%</CenteredTd>
              <CenteredTd>.56</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>37%</CenteredTd>
              <CenteredTd>.59</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>38%</CenteredTd>
              <CenteredTd>.61</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>39%</CenteredTd>
              <CenteredTd>.64</CenteredTd>
            </tr>
          </tbody>
        </Table>
      </Grid>
      <Grid item xs={gridSize}>
        <Table>
          <thead>
            <tr>
              <Th10>{headerText}</Th10>
              <Th10>MULTIPLIER</Th10>
            </tr>
          </thead>
          <tbody>
            <tr>
              <CenteredTd>40%</CenteredTd>
              <CenteredTd>.67</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>41%</CenteredTd>
              <CenteredTd>.69</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>42%</CenteredTd>
              <CenteredTd>.72</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>43%</CenteredTd>
              <CenteredTd>.75</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>44%</CenteredTd>
              <CenteredTd>.79</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>45%</CenteredTd>
              <CenteredTd>.82</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>46%</CenteredTd>
              <CenteredTd>.85</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>47%</CenteredTd>
              <CenteredTd>.89</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>48%</CenteredTd>
              <CenteredTd>.92</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>49%</CenteredTd>
              <CenteredTd>.96</CenteredTd>
            </tr>
            <tr>
              <CenteredTd>50%</CenteredTd>
              <CenteredTd>1.00</CenteredTd>
            </tr>
          </tbody>
        </Table>
      </Grid>
    </Grid>
  );
};

export default CirculationMultiplierTable;
